import React from 'react';
import { CheckCircle2, Users, Award, Target } from 'lucide-react';
import { aboutUsContent, companyInfo, images } from '../data/mock';

const AboutSection = () => {
  const highlights = [
    { icon: Award, label: 'Certificación MCSA', desc: 'Microsoft Certified' },
    { icon: Users, label: '+25 Años', desc: 'De experiencia' },
    { icon: Target, label: 'Socios', desc: 'Microsoft & HP' }
  ];

  return (
    <section id="nosotros" className="py-24 bg-slate-900 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-orange-500/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-6 relative z-10">
        {/* Section header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1 bg-blue-500/10 border border-blue-500/20 rounded-full text-blue-400 text-sm font-medium mb-4">
            Nuestra Historia
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            {aboutUsContent.title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-orange-500 mx-auto rounded-full" />
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image side */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={images.serverRoom}
                alt="Centro de datos profesional"
                className="w-full h-[400px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent" />
            </div>

            {/* Floating stats card */}
            <div className="absolute -bottom-6 -right-6 md:right-8 bg-slate-800 border border-slate-700 rounded-xl p-6 shadow-xl">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 bg-orange-500/20 rounded-full flex items-center justify-center">
                  <Award className="text-orange-400" size={28} />
                </div>
                <div>
                  <p className="text-3xl font-bold text-white">+25</p>
                  <p className="text-slate-400 text-sm">Años de experiencia</p>
                </div>
              </div>
            </div>

            {/* Decorative element */}
            <div className="absolute -top-4 -left-4 w-24 h-24 border-2 border-blue-500/30 rounded-xl" />
          </div>

          {/* Content side */}
          <div className="space-y-6">
            {aboutUsContent.paragraphs.map((paragraph, index) => (
              <p
                key={index}
                className={`text-slate-300 leading-relaxed ${
                  index === 0 ? 'text-lg' : 'text-base'
                }`}
              >
                {paragraph}
              </p>
            ))}

            {/* Highlights */}
            <div className="grid grid-cols-3 gap-4 pt-6">
              {highlights.map((item, index) => (
                <div
                  key={index}
                  className="text-center p-4 bg-slate-800/50 border border-slate-700/50 rounded-xl hover:border-orange-500/50 transition-all duration-300 group"
                >
                  <div className="w-12 h-12 bg-blue-500/10 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:bg-orange-500/10 transition-colors">
                    <item.icon className="text-blue-400 group-hover:text-orange-400 transition-colors" size={24} />
                  </div>
                  <p className="text-white font-semibold text-sm">{item.label}</p>
                  <p className="text-slate-400 text-xs">{item.desc}</p>
                </div>
              ))}
            </div>

            {/* Certifications */}
            <div className="flex items-center gap-3 pt-4">
              <CheckCircle2 className="text-green-400 flex-shrink-0" size={20} />
              <p className="text-slate-300">
                Certificados <strong className="text-white">MCSA</strong> (Microsoft Certified System Administrator)
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
